/**
 * Carousel Dots - Dot Indicator Navigation
 * 
 * Provides dot indicator controls for carousels
 */

document.addEventListener('DOMContentLoaded', function() {
    
    // Initialize all carousel-dots instances
    document.querySelectorAll('.carousel-dots').forEach(carouselDots => {
        initCarouselDots(carouselDots);
    });

    function initCarouselDots(carouselDots) {
        const carouselId = carouselDots.dataset.carouselId;
        const dots = carouselDots.querySelectorAll('.carousel-dots__dot');
        
        if (!dots.length) return;

        let currentSlide = 0;
        
        // Find initially active dot
        dots.forEach((dot, index) => {
            if (dot.classList.contains('active')) {
                currentSlide = index;
            }
        });

        /**
         * Update active slide
         */
        function updateSlide(newIndex) {
            if (newIndex < 0 || newIndex >= dots.length) return;
            
            // Remove active class from current dot
            dots[currentSlide].classList.remove('active');
            
            // Update current index
            currentSlide = newIndex;
            
            // Add active class to new dot
            dots[currentSlide].classList.add('active');
            
            // Dispatch custom event for carousel to listen to
            const event = new CustomEvent('carousel-nav-change', {
                detail: {
                    carouselId: carouselId,
                    slideIndex: currentSlide
                },
                bubbles: true
            });
            carouselDots.dispatchEvent(event);
        }

        /**
         * Dot click navigation
         */
        dots.forEach((dot, index) => {
            dot.addEventListener('click', () => {
                updateSlide(index);
            });
        });

        /**
         * Listen for external slide changes (e.g., from arrows or swipe gestures)
         */
        document.addEventListener('carousel-slide-change', (e) => {
            if (e.detail.carouselId === carouselId) {
                const newIndex = e.detail.slideIndex;
                if (newIndex !== currentSlide && newIndex >= 0 && newIndex < dots.length) {
                    dots[currentSlide].classList.remove('active');
                    currentSlide = newIndex;
                    dots[currentSlide].classList.add('active');
                }
            }
        });
    }
});
